import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { LocationRestService } from "@app/services/hal/location-rest.service";
import { LocationModel } from "@app/models/rest/location";
import {
  HateoasResourceService,
  ResourceCollection
} from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class LocationStore extends RealTimeDataStore<LocationModel> {
  constructor() {
    const locationRestService = inject(LocationRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(locationRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Location");
  }

  findByLongitudeAndLatitude(
    latitude: number,
    longitude: number
  ): Promise<ResourceCollection<LocationModel>> {
    return this.loadUnpagedSearch(
      "findByLongitudeAndLatitude",
      {
        params: {
          longitude: longitude,
          latitude: latitude
        }
      },
      true
    );
  }
}
